<template>
  <div>
    <div class="main-overview restricted-width">
      <en-snackbar ref="snackbar" :type="messageType"></en-snackbar>
      <en-overlay-spinner v-model="loading"></en-overlay-spinner>
      <v-container fluid class="main-header">
        <en-page-title>
          <template #default>
            {{ t('Authentication.settingsTitle') }}
          </template>
        </en-page-title>
        <en-tabs class="full-width-tabs" v-model="currentTab" :tabs="tabs" secondary></en-tabs>
        <div v-if="currentTab === 'general'">
          <general-tab v-model="user" @message-receive="pushMessage"></general-tab>
        </div>
        <div v-if="currentTab === 'password'">
          <password-tab :role="user.Role" @message-receive="pushMessage"></password-tab>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script setup>
import EnOverlaySpinner from 'Components/feedback/EnOverlaySpinner/EnOverlaySpinner';
import EnSnackbar from 'Components/feedback/EnSnackbar/EnSnackbar.vue';
import EnTabs from 'Components/base/EnTabs/EnTabs.vue';
import EnPageTitle from 'Components/layout/EnPageTitle/EnPageTitle.vue';
import GeneralTab from './generalTab.vue';
import PasswordTab from './passwordTab.vue';

const messageType = ref('info');
const snackbar = ref();
const user = ref({});
const loading = ref(true);
const breadcrumbInfo = ref([t('Authentication.settingsTitle')]);
const {updateBreadcrumbs} = inject('breadcrumb');
updateBreadcrumbs(breadcrumbInfo.value);

const currentTab = ref('general');
const tabs = [
  {value: 'general', label: t('Authentication.manage.general.titleV2')},
  {value: 'password', label: t('Authentication.manage.password.titleV2')},
];

function pushMessage(message, type) {
  messageType.value = type;
  snackbar.value.pushMessage(message);
}

onBeforeMount(async () => {
  const requestBody = {Profile: true};
  const response = await fetch(`/api/Configuration/GetConfigurationForUser`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestBody)
  });
  if (response.ok) {
    user.value = (await response.json()).UserProfile;
  }
  loading.value = false;
});
</script>